export default __webpack_public_path__ + "static/media/philanthropy-background.f32f9736.svg";